module.exports = __webpack_public_path__ + "static/media/Camera26.ee68e966.jpg";